const DocumentsCardSkeleton = () => {
  return (
    <div className="flex items-center justify-between p-4 rounded-lg bg-gray-100 animate-pulse">
      {/* Left Section */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-gray-300" />

        <div>
          <div className="w-[120px] h-[14px] rounded bg-gray-300 mb-2" />
          <div className="w-[70px] h-[10px] rounded bg-gray-300" />
        </div>
      </div>

      {/* Right Section */}
      <div className="grid grid-cols-2 gap-2">
        {[1, 2, 3, 4].map((item) => (
          <div
            key={item}
            className="bg-white rounded-full px-3 py-1 flex items-center gap-2"
          >
            <div className="w-2 h-2 rounded-full bg-gray-300" />

            <div className="w-[55px] h-[10px] rounded bg-gray-300" />

            <div className="w-[15px] h-[10px] rounded bg-gray-300" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentsCardSkeleton;